import React, { useCallback } from 'react';
import { Text } from '@box/blueprint-web';
import { useIntl, type MessageDescriptor } from 'react-intl';
import FolderSelectionContentField from '../folder-selection-content-field/folder-selection-content-field';
import messages from './messages';
import css from './folder-selector.module.scss';
import { useBuilderContext } from '../../../components/builder/builder-context';
import selector from '../../../components/builder/builder-context/builder-selector';
import {
  ACTION_CLEAR_FORM_UPLOAD_FOLDER,
  ACTION_OPEN_SELECT_MODAL,
} from '../../../components/builder/builder-context/builder-constant';
import type { FieldError } from '../../../types/form/Element';
import { isFieldError } from '../upload-field/types-utils';

export const FolderSelector = ({
  elementId,
  error,
  shouldShowPanelError = true,
}: {
  elementId: string;
  error?: FieldError | MessageDescriptor;
  shouldShowPanelError?: boolean;
}) => {
  const intl = useIntl();
  const { dispatch, state } = useBuilderContext();
  const componentForId = selector.getComponentForId(state, elementId);
  const { folderInfoById } = state.workingFileRequest;
  const folderId = componentForId?.folderId ?? null;

  const errorMessage: string =
    error && isFieldError(error) && error.panelMessage
      ? intl.formatMessage(error.panelMessage)
      : '';

  const openFolderPickerModal = useCallback(() => {
    dispatch({
      type: ACTION_OPEN_SELECT_MODAL,
      id: elementId,
    });
  }, [dispatch, elementId]);

  const onClickClear = useCallback(() => {
    dispatch({
      type: ACTION_CLEAR_FORM_UPLOAD_FOLDER,
      id: elementId,
    });
  }, [dispatch, elementId]);

  return (
    <>
      <Text as="p" className={css.elementMargin} variant="bodyDefaultBold">
        {intl.formatMessage(messages.contentFieldLabel)}
      </Text>
      <FolderSelectionContentField
        error={shouldShowPanelError ? errorMessage : undefined}
        hintText={intl.formatMessage(messages.contentFieldHintText)}
        folderInfo={
          folderInfoById && folderId ? folderInfoById[folderId] : null
        }
        onClick={openFolderPickerModal}
        onClickClearButton={onClickClear}
      />
    </>
  );
};
